var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "topbar-container" } }, [
    _c("div", { attrs: { id: "topbar-left" } }, [
      _c(
        "div",
        { attrs: { id: "main-nav" } },
        [
          _c("router-link", {
            attrs: { to: { name: "FileList", params: { uuid: _vm.id } } },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({
                  href,
                  route,
                  navigate,
                  isActive,
                  isExactActive,
                }) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "nav-item",
                        class: [
                          isActive && "",
                          isExactActive && "exact-active",
                        ],
                        on: { click: navigate },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("trans")("Files")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("router-link", {
            attrs: { to: { name: "Tools", params: { uuid: _vm.id } } },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({
                  href,
                  route,
                  navigate,
                  isActive,
                  isExactActive,
                }) {
                  return [
                    _vm.currentJob.apiJob?.sat?.permissions.can_continue ===
                    true
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "nav-item d-flex d-inline-flex align-items-center h-100 gap-50",
                            class: [
                              isActive && "",
                              isExactActive && "exact-active",
                            ],
                            on: { click: navigate },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm._f("trans")("Tools")) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "open-files-nav flex-1 overflow-x-auto no-scrollbar",
          attrs: { id: "files-bar-container" },
          on: { wheel: _vm.onWheel },
        },
        _vm._l(_vm.resultPage.openTabs, function (job, index) {
          return _c("router-link", {
            key: index,
            attrs: { to: job.path },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({
                    href,
                    route,
                    navigate,
                    isActive,
                    isExactActive,
                  }) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "nav-item-file",
                          class: [
                            isActive && "active",
                            isExactActive && "active",
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.openTab(job)
                            },
                            mouseup: function ($event) {
                              if ("button" in $event && $event.button !== 1)
                                return null
                              return _vm.remove(job.id, index, isActive)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "tab-icon" }, [
                            _vm.currentJob.state !== "processing"
                              ? _c("i", {
                                  staticClass: "lh-inherit",
                                  class: job.icon,
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.loading
                              ? _c("i", {
                                  staticClass: "lh-inherit spin-circle-basic",
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            job.type === "preview_image"
                              ? _c("strong", [_vm._v("Preview")])
                              : _vm._e(),
                            _vm._v(" "),
                            job.type === "meta_info"
                              ? _c("strong", [_vm._v("File Info")])
                              : _vm._e(),
                            _vm._v(" "),
                            job.type === "file_list" ? _c("strong") : _vm._e(),
                            _vm._v(" "),
                            job.state === "processing"
                              ? _c("i", {
                                  staticClass:
                                    "fa fa-spin btn-loading-animation lh-inherit",
                                })
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "file-text" }, [
                            _vm._v(_vm._s(_vm.translate(job.name))),
                          ]),
                          _vm._v(" "),
                          job.dismissable
                            ? _c("i", {
                                staticClass: "far fa-times lh-inherit",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.remove(job)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !job.dismissable ? _c("span") : _vm._e(),
                        ]
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          })
        }),
        1
      ),
      _vm._v(" "),
      _vm.resultPage.openTabs.length > 2
        ? _c("div", { staticClass: "topbar-scroll-container" }, [
            _c("i", {
              staticClass: "lh-inherit fa fa-chevron-left",
              on: { click: _vm.scrollLeft },
            }),
            _vm._v(" "),
            _c("i", {
              staticClass: "lh-inherit fa fa-chevron-right",
              on: { click: _vm.scrollRight },
            }),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "topbar-right" } }, [
      _c(
        "div",
        { staticClass: "d-flex justify-content-end h-100" },
        [
          _c("router-link", {
            attrs: { to: { name: "Feedback", params: { uuid: _vm.id } } },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({
                  href,
                  route,
                  navigate,
                  isActive,
                  isExactActive,
                }) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "nav-item",
                        class: [
                          isActive && "",
                          isExactActive && "exact-active",
                        ],
                        on: { click: navigate },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                            },
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: { fill: "none", "fill-rule": "evenodd" },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    fill: "currentColor",
                                    d: "m20.255 5.52l.087.298l.089.338l.044.185l.089.4l.085.443l.081.485c.026.169.05.345.074.528l.065.572c.08.791.131 1.7.131 2.731s-.05 1.94-.13 2.731l-.066.572c-.023.183-.048.36-.074.528l-.08.485l-.086.443l-.089.4l-.089.36l-.088.317l-.043.144c-.331 1.087-1.464 1.505-2.394 1.195l-1.18-.393l-.4.933a2 2 0 0 1-2.47 1.11l-5.096-1.7a2 2 0 0 1-1.206-2.684l.269-.628L7 15.055l-1.368.456A2 2 0 0 1 3 13.613V9.388A2 2 0 0 1 5.632 7.49L7 7.946l10.861-3.62c.93-.31 2.063.107 2.394 1.194M9.682 15.948l-.335.78l5.096 1.7l.335-.781zm8.706-9.69L8 9.721v3.558l10.388 3.463l.077-.283l.08-.327l.04-.18l.078-.394a17.8 17.8 0 0 0 .076-.439l.07-.485c.112-.847.191-1.887.191-3.134c0-1.246-.08-2.287-.19-3.134l-.071-.485c-.025-.154-.05-.3-.076-.44l-.079-.393l-.08-.349zM5 9.388v4.225l1-.334V9.721z",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("trans")("Give us your feedback")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }